var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-page-container",
      attrs: { a_id: "login-page-container", "extension-name": "login-page" }
    },
    [
      _c(
        "div",
        {
          staticClass: "login-page-header",
          attrs: { a_id: "login-page-header" }
        },
        [
          _vm.isTargetAgent
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm._f("translate")("LoginPage.AgentLogin")) +
                    "\n\t\t\t"
                )
              ])
            : _c("span", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm._f("translate")("LoginPage.LoginHeaderStart")) +
                    " "
                ),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm._f("translate")("LoginPage.LoginHeaderEnd"))
                  )
                ])
              ])
        ]
      ),
      _vm._v(" "),
      _vm.qrcode
        ? _c(
            "div",
            {
              staticClass: "mfa-page-sub-title",
              attrs: { a_id: "mfa-page-sub-title" }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("translate")("LoginMFAPage.enableMFATitle")) +
                  "\n        "
              )
            ]
          )
        : _c(
            "div",
            {
              staticClass: "mfa-page-sub-title",
              attrs: { a_id: "mfa-page-sub-title" }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("translate")("LoginMFAPage.mfaTitle")) +
                  "\n        "
              )
            ]
          ),
      _vm._v(" "),
      _vm.qrcode
        ? _c(
            "div",
            {
              staticClass: "mfa-page-scan-code",
              attrs: { a_id: "mfa-page-scan-code" }
            },
            [
              _c("div", { staticClass: "mfa-page-scan-code-text" }, [
                _vm._v(_vm._s(_vm._f("translate")("LoginMFAPage.scanCode")))
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "mfa-page-qrcode-image",
                attrs: { src: _vm.qrcode }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "mfa-page-field-label" }, [
            _vm._v(_vm._s(_vm._f("translate")("LoginMFAPage.codeChallenge")))
          ]),
          _vm._v(" "),
          _c("login-page-field", {
            attrs: {
              "input-id": "mfaCode",
              a_id: "login-page-field-mfaCode",
              imageType: "password",
              placeholder: _vm._f("translate")(
                "LoginMFAPage.codeChallengePlaceholder"
              ),
              "show-error-message": _vm.loginFailed,
              "error-message":
                _vm.errorMessage ||
                "LoginPage.InvalidPasswordErrorMessage" | _vm.translate
            },
            on: { enter: _vm.mfaCodeClicked },
            model: {
              value: _vm.mfaCode,
              callback: function($$v) {
                _vm.mfaCode = $$v
              },
              expression: "mfaCode"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "login-page-footer",
              attrs: { a_id: "login-page-footer" }
            },
            [
              _vm.mfaCode && !_vm.locked
                ? _c(
                    "button",
                    {
                      staticClass: "login-page-footer-button",
                      attrs: { a_id: "login-page-footer-login-button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.mfaCodeClicked($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm._f("translate")("LoginMFAPage.verifyButton")
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "login-page-footer-button",
                      attrs: {
                        disabled: "",
                        a_id: "login-page-footer-login-button-disabled"
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm._f("translate")("LoginMFAPage.verifyButton")
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d572815", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d572815","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/LoginMFAPage.vue
// module id = 442
// module chunks = 0